import webUserAPI from '../../data/web-user-api';
import { startLoading, endLoading } from './loading-actions';

const putWebUserStatusRefreshFail = error => (window as any).errorManager.captureException(error, true);

const putWebUserStatusRefresh = status => dispatch => {
  dispatch(startLoading());

  try {
    webUserAPI.putWebUserStatusRefresh(status);
    dispatch(endLoading());
  } catch (ex) {
    dispatch(endLoading());
    putWebUserStatusRefreshFail(ex);
  }
};

export default putWebUserStatusRefresh;
